<template>
  <div class="brands-table">
    <el-table :data="brands.data" class="w100" @sort-change="sortMethod" stripe>
      <el-table-column>
        <template slot-scope="props">
          <img :src="props.row.image" class="brands-table__image" alt="brand image">
        </template>
      </el-table-column>
      <el-table-column label="Name" prop="name" sortable></el-table-column>
      <el-table-column label="Company Name" prop="company_name" sortable></el-table-column>
      <el-table-column label="Publish Date" sortable>
        <template slot-scope="props">
          {{ props.row.published_at ? moment(props.row.published_at).format('DD-MMM-YY') : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="props">
          <el-tooltip content="Open on SV" placement="top">
            <el-button type="info" circle size="small" icon="el-icon-s-promotion"></el-button>
          </el-tooltip>
          <el-tooltip content="Edit Brand" placement="top">
            <el-button type="warning" circle size="small" icon="el-icon-edit"
                       @click="openModal(props.row)"></el-button>
          </el-tooltip>
          <el-tooltip :content="props.row.published_at ? 'Unpublish' : 'Publish'" placement="top">
            <el-button type="default" circle size="small"
                       :icon="props.row.published_at ? 'el-icon-close' : 'el-icon-check'"
                       @click="publishBrand(props.row)"></el-button>
          </el-tooltip>
          <el-tooltip
            v-if="props.row.socials.length>0"
            content="Campaign reports"
          >
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-document"
              @click="openDialog(props.row.id, props.row.socials)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete Brand" placement="top">
            <el-button type="primary" circle size="small" icon="el-icon-delete"
                       @click="deleteBrand(props.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="float-right" background @size-change="sizeChange" @current-change="currentChange"
                   :current-page.sync="brands.current_page" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="brands.total"
    ></el-pagination>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1122"
      filename="PDF Reports"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="795px"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2PdfChallenge"
    >
      <section slot="pdf-content">
        <ReportChallenge
          type="brand"
          :pdf_report="pdf_report"
          :challenge_type="challenge_type"
          :countries_chart="countries_chart"
          :chart_pdf="PieChartSettPdf"
          :pdc="publish_date_challenge"
        />
      </section>
    </vue-html2pdf>
    <el-dialog
      title="Challenge reports"
      :visible="dialog"
      width="400px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="dialog = false"
    >
      <div>
        <div class="flex-space-around">
          <div class="challenge_reports">
            <div  v-if="shortsButton || tiktokButton || instagramButton">
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-document"
                  @click="generateShortsReport(brand_id)"
                  class="mb10"
                  v-if="shortsButton"
                >Download Shorts report
                </el-button>
              </div>
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-document"
                  @click="generateTikTokReport(brand_id)"
                  class="mb10"
                  v-if="tiktokButton"
                >Download TikTok report
                </el-button>
              </div>
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-document"
                  @click="generateInstagramReport(brand_id)"
                  class="mb10"
                  v-if="instagramButton"
                >Download Instagram report
                </el-button>
              </div>
              <p>
                <el-checkbox label="Publish date" v-model="publish_date_challenge"></el-checkbox>
              </p>
            </div>
            <div v-else>No data</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import VueHtml2pdf from 'vue-html2pdf';
import ReportChallenge from "../../shared/VCPdfReportChallenge"
import moment from "moment";

export default {
  name: "Table",
  components: {
    VueHtml2pdf,
    ReportChallenge
  },
  data() {
    return {
      moment: moment,
      dialog: false,
      shortsButton:false,
      tiktokButton:false,
      instagramButton:false,
      brand_id: 0,
      publish_date_challenge: 0,
      htmlToPdfOptions: {
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: true,
        html2canvas: {
          dpi: 192,
          scale:4,
          letterRendering: true,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        },
        filename: 'file.pdf'
      },
    }
  },

  computed: {
    ...mapState('brand', ['brands', 'pageSize', 'pdf_report', 'challenge_type',
      'PieChartSettPdf']),
    ...mapGetters('brand', ['countries_chart']),
  },

  methods: {
    ...mapMutations('brand', [
        'setBrand', 'setModal', 'setModalAction', 'setOrder', 'setCurrentPage', 'setPageSize'
    ]),
    ...mapActions('brand', [
        'getBrands', 'getSocials', 'getRestrictions', 'deleteBrand', 'publish','readShortsReport','readTikTokReport','readInstagramReport',
    ]),

    publishBrand(brand) {
      this.publish({brandId: brand.id, status: brand.published_at ? 0 : 1 })
    },

    openModal(brand) {
      brand = { ...brand }
      brand.socials = brand.socials.map(s => s.id)
      brand.restrictions = brand.restrictions.map(r => r.name)

      this.setBrand(brand)
      this.setModalAction('update')
      this.setModal(true)
    },
    openDialog(id, socials) {
      this.dialog = true
      this.brand_id = id
      this.shortsButton = !!socials.find(s => s.name === 'YouTube Short')
      this.tiktokButton = !!socials.find(s => s.name === 'TikTok')
      this.instagramButton = !!socials.find(s => s.name === 'Instagram')
    },
    sortMethod(sort) {
      if (!sort.prop || !sort.order) return

      const order = { 'descending': 'desc', 'ascending': 'asc' }[sort.order]

      this.setCurrentPage(1)
      this.setOrder(`orderBy=${sort.prop},${order}`)

      this.getBrands()
    },

    sizeChange(page) {
      this.setPageSize(page)
      this.getBrands()
    },

    currentChange(page) {
      this.setCurrentPage(page)
      this.getBrands()
    },
    generateShortsReport(id) {
      this.loading = true
      let send = {
        id: id,
      }
      this.readShortsReport(send).then(() => {
        let filename = this.pdf_report.brand_name + '_Shorts'
        filename = filename.replace(/\s/g, '_')
        //filename = filename.toLowerCase()
        this.htmlToPdfOptions.filename = filename + '.pdf'
        setTimeout(() => {
          this.$refs.html2PdfChallenge.generatePdf()
          this.loading = false
        }, 1000)
      })
    },
    generateTikTokReport(id) {
      this.loading = true
      let send = {
        id: id,
      }
      this.readTikTokReport(send).then(() => {
        let filename = this.pdf_report.brand_name + '_TikTok'
        filename = filename.replace(/\s/g, '_')
        //filename = filename.toLowerCase()
        this.htmlToPdfOptions.filename = filename + '.pdf'
        setTimeout(() => {
          this.$refs.html2PdfChallenge.generatePdf()
          this.loading = false
        }, 1000)
      })
    },
    generateInstagramReport(id) {
      this.loading = true
      let send = {
        id: id,
      }
      this.readInstagramReport(send).then(() => {
        let filename =  this.pdf_report.brand_name + '_Instagram'
        filename = filename.replace(/\s/g, '_')
        //filename = filename.toLowerCase()
        this.htmlToPdfOptions.filename = filename + '.pdf'
        setTimeout(() => {
          this.$refs.html2PdfChallenge.generatePdf()
          this.loading = false
        }, 1000)
      })
    },
  },

  created() {
    this.getBrands()
    this.getSocials()
    this.getRestrictions()
  }
}
</script>

<style scoped lang="scss">

.brands-table {

  &__image {
    border-radius: 50%;
    height: 60px;
    width: 60px;
  }
}
.challenge_reports{
  padding: 20px 0;
  button{
    width:100%;
    text-align: left;
  }

}

</style>
